import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import '../styles/CustomerTypeForm.css';
import fetchApi from '../utils/api.js';
import Swal from 'sweetalert2';

const CustomerTypeForm = ({ isOpen, onClose, customerType, isPage, type = 'customer' }) => {
    const [name, setName] = useState('');
    const [companyId, setCompanyId] = useState('');
    const [companies, setCompanies] = useState([]);
    const [userRole, setUserRole] = useState('');

    const typeLabel = type === 'seller' ? 'Seller Type' : type === 'transporter' ? 'Transporter Type' : 'Customer Type';

    useEffect(() => {
        const userStr = sessionStorage.getItem('user');
        if (userStr) {
            const user = JSON.parse(userStr);
            setUserRole(user.role);
            if (user.role === 'SUPER_ADMIN') {
                fetchCompanies();
            }
        }
    }, [isOpen]);

    useEffect(() => {
        if (customerType) {
            setName(customerType.customerTypeName || customerType.customer_type_name || '');
            const cid = customerType.companyId || customerType.company_id;
            setCompanyId(cid ? cid : 'all');
        } else {
            setName('');
            setCompanyId('');
        }
    }, [customerType]);

    const fetchCompanies = async () => {
        try {
            const data = await fetchApi('/company');
            setCompanies(data.companies || data);
        } catch (error) {
            console.error('Error fetching companies:', error);
        }
    };

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();
        const conf = await Swal.fire({
            title: 'Save Data?',
            text: 'Are you sure you want to save this data?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#00334e',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Save',
            cancelButtonText: 'No, Keep Editing'
        });
        if (!conf.isConfirmed) return;

        const trimmedName = name.trim();
        if (!trimmedName) {
            toast.error("Name is required");
            return;
        }

        const isSuperAdmin = userRole === 'SUPER_ADMIN';
        if (isSuperAdmin && !companyId) {
            toast.error("Please select a company");
            return;
        }

        try {
            const endpoint = customerType
                ? `/customer-type/${customerType._id || customerType.id}`
                : '/customer-type';
            const method = customerType ? 'PUT' : 'POST';

            const payload = { customerTypeName: trimmedName, type };
            if (isSuperAdmin) {
                payload.companyId = companyId;
            }

            await fetchApi(endpoint, {
                method,
                body: JSON.stringify(payload)
            });

            toast.success(customerType ? `${typeLabel} Updated Successfully` : `${typeLabel} Added Successfully`);
            onClose();
        } catch (error) {
            console.error("Submit error:", error);
            toast.error(error.message || "Operation failed");
        }
    };

    if (!isOpen) return null;

    return (
        <div className={isPage ? "list-page-container" : "modal-overlay"}>
            <div className={isPage ? "" : "modal"}>
                <div className="modal-header">
                    <h2 className="modal-title">{customerType ? `Update ${typeLabel}` : `Add ${typeLabel}`}</h2>
                    {!isPage && <button className="modal-close" onClick={onClose}>&times;</button>}
                </div>
                <div className="customertype-form-body">
                    <form onSubmit={handleSubmit}>
                        <div className="customertype-grid">
                            {userRole === 'SUPER_ADMIN' && (
                                <div className="customertype-field">
                                    <label>COMPANY <span style={{ color: 'red' }}>*</span></label>
                                    <select
                                        value={companyId}
                                        onChange={(e) => setCompanyId(e.target.value)}
                                        required
                                        style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                                    >
                                        <option value="">Select Company</option>
                                        <option value="all">All</option>
                                        {companies.map(c => (
                                            <option key={c._id || c.id} value={c._id || c.id}>
                                                {c.companyName || c.name || c.company_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}
                            <div className="customertype-field">
                                <label>NAME</label>
                                <input
                                    type="text"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    placeholder={`Enter ${typeLabel} Name`}
                                    required
                                />
                            </div>
                        </div>

                        <div className="customertype-form-actions">
                            <button type="submit" className="btn-submit">Submit</button>
                            <button type="button" className="btn-cancel" onClick={onClose}>Cancel</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CustomerTypeForm;
